/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ShortcodeAction {
    NONE = 'None',
    CREATE_WORKFLOW_FOR_USER = 'CreateWorkflowForUser',
    CREATE_FORM_RESPONSE_IN_WORKFLOW = 'CreateFormResponseInWorkflow',
}
